
/* styles */
require("!!vue-style-loader!css-loader!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4f49d903!sass-loader?indentedSyntax!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Topbar.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Topbar.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4f49d903!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Topbar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/Topbar.vue
// module id = 203
// module chunks = 22